export const textStyles = {
  subtitle: {
    fontSize: { base: '16px', md: '18px' },
    lineHeight: { base: '22px', md: '24px' }
  },
  button: {
    fontSize: 'md',
    fontWeight: 600
  },
  body: {
    fontSize: { base: '14px', md: '16px' },
    lineHeight: { base: '18px', md: '22px' }
  },
  bodySmall: {
    fontSize: { base: '13px', md: '14px' },
    lineHeight: { base: '17px', md: '18px' }
  },
  bodySuperSmall: {
    fontSize: '12px',
    lineHeight: '16px'
  },
  note: {
    fontSize: '12px',
    lineHeight: '16px'
  },
  caption: {
    fontSize: '12px'
  },
  overline: {
    fontSize: '13px',
    lineHeight: '18px'
  },
  label: {
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 400,
    letterSpacing: '0.12em',
    textTransform: 'uppercase'
  },
  breadcrumb: {
    cursor: 'pointer',
    fontSize: { base: '12px', md: '13px' },
    fontWeight: { base: 500, md: 600 }
  }
}
